import moment from 'moment'
import React, { useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import PopUpDetails from '../../statements/PopUpDetails'

function CardStatementReport({ langLocal, selectedIds, translate, handleCheckboxChange, datum }) {
    const { dispatch, navigate } = AbstructVar()
    const [statement_id, setStatementId] = useState(null)
    const [openDetails, setOpenDetails] = useState(null)
    return (
        <>
            <div className='card-report-account' onClick={(e) => {
                e.stopPropagation();
                setStatementId(datum?.id); setOpenDetails(true)
            }} >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative" }}>
                    <div style={{ width: "100%" }} className='one-card-report-account' >
                        <span>{translate('statement_number')}</span>
                        <span>{datum.number}</span>
                    </div>
                    <input
                        className='checkbox-report-accoun'
                        style={langLocal === 'ar' ? { left: 0 } : { right: 0 }}
                        type='checkbox'
                        checked={selectedIds.includes(datum.id)}
                        onClick={(e) => {e.stopPropagation();handleCheckboxChange(datum.id)}}
                    />
                </div>
                <div className='one-card-report-account' >
                    <span>{translate('statement_date')}</span>
                    <span>{moment(datum?.statement_date).format("YYYY-MM-DD")}</span>
                </div>

                <div className='one-card-report-account' >
                    <span>{translate('project')}</span>
                    <span>{datum?.project?.name}</span>
                </div>
                <button className='btn-accoutn-expenses' onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault()
                navigate(`/statements-expenses/${datum?.id}`)
                }}  >{translate('view_expense')}</button>
            </div>
            {
                openDetails && (
                    <PopUpDetails statement_id={statement_id} open={openDetails} setOpen={setOpenDetails} />
                )
            }
        </>
    )
}

export default CardStatementReport